import { SpeciesSearchScreen } from '@screens/SpeciesSearch/SpeciesSearchScreen';

export default function EditReportSpeciesScreen(): React.ReactNode {
  return <SpeciesSearchScreen />;
}
